/*
 * @Description: 
 * @version: 
 * @Author: 代世阳
 * @Date: 2021-07-14 10:38:11
 * @LastEditTime: 2022-11-29 14:20:58
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios';
import router from './router'
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.config.productionTip = false

// 超时时间
axios.defaults.timeout = 10000;
// 默认地址
axios.defaults.baseURL = config.api_url;
// 是否允许跨域
axios.defaults.withCredentials = true;

// axios.defaults.headers['Content-Type'] = "application/x-www-form-urlencoded; charset=UTF-8";

Vue.prototype.axios = axios;
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js